import React, { useState } from "react";
import "./Pricing.css";
import blurImg from "../../assets/pricing/Ellipse 101 (1).png";
import { Link, useNavigate } from "react-router-dom";
import { TbMoodKid } from "react-icons/tb";
import IconsMovement from "../../Components/IconsMovement/IconMovement";
import Footer from "../../Components/Footer/Footer";
import { TiTick } from "react-icons/ti";
import { RxCross2 } from "react-icons/rx";
import Scrolling from "../../Components/Scrolling/Scrolling";
import { FaCaretDown } from "react-icons/fa";

const amounts = [
  {
    base: {
      price: "3500",
      totalPrice: "10500",
      name: "PER QUATERLY",
      plan: "quaterly base ",
    },
    premium: {
      price: "5000",
      totalPrice: "15000",
      name: "PER QUATERLY",
      plan: "quaterly premium ",
    },
    advance: {
      price: "7500",
      totalPrice: "22500",
      name: "PER QUATERLY",
      plan: "quaterly advance ",
    },
  },
  {
    base: {
      price: "3500",
      totalPrice: "17500",
      name: "PER HALF YEARLY",
      month: "   1 Month Free",
      plan: "half yearly base ",
    },
    premium: {
      price: "5000",
      totalPrice: "25000",
      name: "PER HALF YEARLY",
      month: "   1 Month Free",
      plan: "half yearly premium ",
    },
    advance: {
      price: "7500",
      totalPrice: "37500",
      name: "PER HALF YEARLY",
      month: "   1 Month Free",
      plan: "half yearly advance ",
    },
  },
  {
    base: {
      price: "3500",
      totalPrice: "35500",
      name: "PER YEAR",
      month: "   2 Months Free",
      plan: "year base ",
    },
    premium: {
      price: "5000",
      totalPrice: "50000",
      name: "PER YEAR",
      month: "   2 Months Free",
      plan: "year premium ",
    },
    advance: {
      price: "7500",
      totalPrice: "75000",
      name: "PER YEAR",
      month: "   2 Months Free",
      plan: "year advance ",
    },
  },
];

const Pricing = () => {
  const [selectedOption, setSelectedOption] = useState(0); // Track the selected button
  const [amount, setAmount] = useState(amounts[0]);
  console.log(selectedOption, "selectedOption");
  const [activeSubMenu, setActiveSubMenu] = useState(null); // Track which submenu is active

  const toggleSubMenu = (index) => {
    // setActiveSubMenu(activeSubMenu === index ? null : index);
    setActiveSubMenu(index);
  };
  const toggleSubMenuLeave = (index) => {
    setActiveSubMenu(null);
  };

  const persons = [
    {
      firstname: "Users",
      base: "Upto 30 Users",
      premium: "Upto 60 Users",
      advance: "Upto 100 Users",
    },
    {
      firstname: "Dashboard Analytics",
      base: <TiTick />,
      premium: <TiTick />,
      advance: <TiTick />,
    },
    {
      firstname: "Business Development",
      icon: <FaCaretDown />,
      items: [
        "Proposal quotation",
        "Invoice Generation",
        "Billing Management",
        "Hot Lead Management",
      ],
      base: <TiTick />,
      premium: <TiTick />,
      advance: <TiTick />,
    },
    {
      firstname: "Project Management",
      icon: <FaCaretDown />,
      items: ["Team task Progress", "Completion of Project", "Kanban Board"],
      base: <TiTick />,
      premium: <TiTick />,
      advance: <TiTick />,
    },
    {
      firstname: "Finance",
      icon: <FaCaretDown />,
      items: ["Expense Management", "Monthly Revenue", "Financial Management"],
      base: <TiTick />,
      premium: <TiTick />,
      advance: <TiTick />,
    },
    {
      firstname: "HR",
      icon: <FaCaretDown />,
      items: [
        "Attendance",
        "Employee self service",
        "Tasks",
        "Expenses",
        "Job Management",
      ],
      base: <TiTick />,
      premium: <TiTick />,
      advance: <TiTick />,
    },
    {
      firstname: "Notes",
      base: <TiTick />,
      premium: <TiTick />,
      advance: <TiTick />,
    },
    {
      firstname: "Lead Generation",
      icon: <FaCaretDown />,
      items: ["Lead Generation Project", "Database Management"],
      base: <RxCross2 />,
      premium: <TiTick />,
      advance: <TiTick />,
    },
    {
      firstname: "Chat Management",
      base: <RxCross2 />,
      premium: <TiTick />,
      advance: <TiTick />,
    },
    {
      firstname: "Priority Support",
      base: <RxCross2 />,
      premium: <TiTick />,
      advance: <TiTick />,
    },
    {
      firstname: "Marketing",
      icon: <FaCaretDown />,
      items: [
        "Marketing Calendar",
        "Inbound Leads Management",
        "Existing Clients",
        "Marketing Strategies",
        "Blogs",
      ],
      base: <RxCross2 />,
      premium: <TiTick />,
      advance: <TiTick />,
    },
    {
      firstname: "Form Integrations",
      base: <RxCross2 />,
      premium: <TiTick />,
      advance: <TiTick />,
    },
    {
      firstname: "Custom form Integrations",
      base: <RxCross2 />,
      premium: <RxCross2 />,
      advance: <TiTick />,
    },
    {
      firstname: "Multi Document Selection",
      base: <RxCross2 />,
      premium: <RxCross2 />,
      advance: <TiTick />,
    },
    {
      firstname: "Your Website Integration Support",
      base: <RxCross2 />,
      premium: <RxCross2 />,
      advance: <TiTick />,
    },
    {
      firstname: "Dedicated Support",
      base: <RxCross2 />,
      premium: <RxCross2 />,
      advance: <TiTick />,
    },
    {
      firstname: "Training & Learning",
      icon: <FaCaretDown />,
      items: ["Module Dashboard"],
      base: <RxCross2 />,
      premium: <RxCross2 />,
      advance: <TiTick />,
    },
  ];

  const handleButtonClick = (option) => {
    setSelectedOption(option);
    setAmount(amounts[option]);
  };

  const [text, setText] = useState();

  function Price(ev) {
    setText(ev);
  }
  const navigate = useNavigate();
  const handleNavigate = (plan) => {
    sessionStorage.setItem("selectedPlan", JSON.stringify(plan));
    // navigate("/Signup");
    window.location.href = "https://app.oraddo.com/signup";
  };
  return (
    <div>
      <div className="pricing_container">
        {/* <div className="enterprise_plan_free">
          <div className="enterprise_plan_content">
            <h1>30 days Free Trial</h1>
            <p>
              Experience Oraddo's Free Plan with essential tools to manage your
              business efficiently. Perfect for startups and small teams,
              offering basic features to streamline workflows and enhance
              productivity.
            </p>
          </div>
          <div className="enterprise_plan_button">
            <Link to="/Signup">
              <button>Try Now!</button>
            </Link>
          </div>
        </div> */}
        <div className="pricing_top_content">
          <p className="pricing_plan">Pricing Plan</p>
          <h1>Find the Perfect Plan for Your Business</h1>
          <p className="pricing_plan_content">
            Choose the plan that fits your needs and take your business to the
            next level with powerful tools designed for growth.
          </p>
        </div>

        <div className="pricing_buttons">
          <p
            className={`pricing_button_option ${
              selectedOption === 0 ? "pricing_button_selected1" : ""
            }`}
            onClick={() => handleButtonClick(0)}
          >
            Quarterly
          </p>
          <p
            className={`pricing_button_option ${
              selectedOption === 1 ? "pricing_button_selected2" : ""
            }`}
            onClick={() => handleButtonClick(1)}
          >
            Half Yearly
          </p>
          <p
            className={`pricing_button_option ${
              selectedOption === 2 ? "pricing_button_selected3" : ""
            }`}
            onClick={() => handleButtonClick(2)}
          >
            Yearly
          </p>
        </div>

        <div className="pricing_prices_container">
          <div
            className={
              text === "one"
                ? "pricing_price_card_hover active"
                : "pricing_price_card"
            }
            onMouseOver={() => Price("one")}
          >
            <p>Basic Plan</p>
            <div className="pricing_price_details">
              <h1>
                ₹{amount.base.price}.<span>00</span>
              </h1>
              <p>Per Month</p>
              {selectedOption > 0 && ( // Display months free for half-yearly or yearly
                <p className="months_free">
                  {selectedOption === 1 ? amount.base.month : ""}
                  {selectedOption === 2 ? amount.base.month : ""}
                </p>
              )}
            </div>
            <div className="pricing_price_content">
              <p>
                Get essential tools for business management, including
                analytics, project management, HR, finance, and more. Perfect
                for small teams starting their growth journey.
              </p>
            </div>
            <div className="pricing_price_points">
              <p className="befor_img">Dashboard Analytics</p>
              <p className="befor_img">Business Development</p>
              <p className="befor_img">Project Management</p>
              <p className="befor_img">Finance</p>
              <p className="befor_img">HR</p>
              <p className="befor_img">Notes</p>
              <p className="befor_img">Upto 30 Users</p>
            </div>
            <div
              className={
                text === "one"
                  ? "pricing_price_btn_active"
                  : "pricing_price_btn"
              }
            >
              <button onClick={() => handleNavigate(amount.base.plan)}>
                {text === "one" ? "Let’s Started" : "Start now"}
              </button>
            </div>
            <p className="pricing_card_bottom_price">
              {text === "one"
                ? `${amount.base.name} ${amount.base.totalPrice}/-`
                : ""}
            </p>
          </div>
          <div
            className={
              text === "two"
                ? "pricing_price_card_hover2 active"
                : "pricing_price_card2"
            }
            onMouseOver={() => Price("two")}
          >
            <p>Premium Plan</p>
            <div className="pricing_price_details2">
              <h1>
                ₹{amount.premium.price}.<span>00 </span>
              </h1>
              <p>Per Month</p>
              {selectedOption > 0 && ( // Display months free for half-yearly or yearly
                <p className="months_free">
                  {selectedOption === 1 ? amount.premium.month : ""}
                  {selectedOption === 2 ? amount.premium.month : ""}
                </p>
              )}
            </div>
            <div className="pricing_price_content2">
              <p>
                Premium Plan Build on the Basic Plan with advanced features like
                lead generation, chat management, marketing, and seamless form
                integration to elevate your business.
              </p>
            </div>
            <div className="pricing_price_points2">
              <p className="befor_img">Everything in Basic plan</p>
              <p className="befor_img">Lead Generation</p>
              <p className="befor_img">Chat Management</p>
              <p className="befor_img">Priority Support</p>
              <p className="befor_img">Marketing</p>
              <p className="befor_img">Upto 60 Users</p>
              <p className="befor_img">Form Integrations</p>
            </div>
            <div
              className={
                text === "two"
                  ? "pricing_price_btn_active"
                  : "pricing_price_btn2"
              }
            >
              <button onClick={() => handleNavigate(amount.premium.plan)}>
                {text === "two" ? "Let’s Started" : "Start now"}
              </button>
            </div>
            <p className="pricing_card_bottom_price">
              {text === "two"
                ? `${amount.premium.name} ${amount.premium.totalPrice}/-`
                : ""}
            </p>
          </div>
          <div
            className={
              text === "three"
                ? "pricing_price_card_hover active"
                : "pricing_price_card"
            }
            onMouseOver={() => Price("three")}
          >
            <p>Advanced Plan</p>
            <div className="pricing_price_details">
              <h1>
                ₹{amount.advance.price}.<span>00 </span>
              </h1>
              <p>Per Month</p>
              {selectedOption > 0 && ( // Display months free for half-yearly or yearly
                <p className="months_free">
                  {selectedOption === 1 ? amount.advance.month : ""}
                  {selectedOption === 2 ? amount.advance.month : ""}
                </p>
              )}
            </div>
            <div className="pricing_price_content">
              <p>
                Maximize efficiency with custom form integration, multi-document
                selection, and training resources, alongside all Premium Plan
                features. Ideal for large-scale operations.
              </p>
            </div>
            <div className="pricing_price_points">
              <p className="befor_img">Everything in Premium Plan</p>
              <p className="befor_img">Custom form Integrations</p>
              <p className="befor_img">Multi Document Selection</p>
              <p className="befor_img">Your Website Integration Support</p>
              <p className="befor_img">Dedicated Support</p>
              <p className="befor_img">Training & Learning</p>
              <p className="befor_img">Upto 100 Users</p>
            </div>
            <div
              className={
                text === "three"
                  ? "pricing_price_btn_active"
                  : "pricing_price_btn"
              }
            >
              <button onClick={() => handleNavigate(amount.advance.plan)}>
                {text === "three" ? "Let’s Started" : "Start now"}{" "}
              </button>
            </div>
            <p className="pricing_card_bottom_price">
              {text === "three"
                ? `${amount.advance.name} ${amount.advance.totalPrice}/-`
                : ""}
            </p>
          </div>
        </div>
        <div className="pricing_circle">
          {/* <img src={blurImg} alt="blurImg"/> */}
        </div>

        <div className="enterprise_plan_outer">
          <div className="enterprise_plan_content">
            <h1>For enterprise plan </h1>
            <p>
              Oraddo's Enterprise Plan is designed for businesses with over 100
              people, providing the tools to grow, stay secure, and succeed.
            </p>
          </div>
          <div className="enterprise_plan_button">
            <Link to="/Login">
              <button>Contact our Sales Team</button>
            </Link>
          </div>
        </div>
      </div>
      <div className="compare_plans_outer">
        <div className="compare_plans_table">
          <h1>Compare Plans</h1>
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Basic Plan</th>
                <th>Premium Plan</th>
                <th>Advanced Plan</th>
              </tr>
            </thead>

            <tbody>
              {persons.map((person, ind) => (
                // return (
                <tr key={ind}>
                  <td
                    style={{ textAlign: "start", paddingLeft: "5vw" }}
                    onMouseEnter={() => toggleSubMenu(ind)}
                    onMouseLeave={() => toggleSubMenuLeave(ind)}
                  >
                    {person.firstname}
                    {person.items && (
                      <div className="sub_menu">
                        <p>{person.icon}</p>
                        <ul
                          style={{
                            display: activeSubMenu === ind ? "block" : "none",
                          }}
                        >
                          {person.items.map((item, itemIndex) => (
                            <li key={itemIndex}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </td>
                  <td>{person.base}</td>
                  <td>{person.premium}</td>
                  <td>{person.advance}</td>
                </tr>
                // );
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="pricing_icons">
        <IconsMovement />
      </div>
      <div className="pricing_footer">
        <Footer />
        <Scrolling />
      </div>
    </div>
  );
};

export default Pricing;
